import React, { useRef } from "react";
import Button from "components/atoms/Button";
import { Wrapper } from "./styles";

interface DownloadDropdownProps {
  onDownloadDashboard: () => void;
  onDownloadFullReport: () => void;
  isDashboardDownloadable: boolean;
}

const DownloadDropdown: React.FC<DownloadDropdownProps> = ({
  onDownloadFullReport,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const handleDownloadFullReport = () => {
    onDownloadFullReport();
  };

  return (
    <Wrapper ref={ref}>
      <Button
        variant="secondary"
        width="auto"
        onClick={handleDownloadFullReport}
      >
        Download Short Report
      </Button>
    </Wrapper>
  );
};

export default DownloadDropdown;
